import { SwitchCity } from "@travelata-libs/travelata-frontend";
import { Region } from "../model/types";

declare let window: { appConfig: { static: { regions: Region[], currentRegion: number } } };

export function getPanelList(): (SwitchCity & { el: HTMLElement | null })[] {
    const regions = window.appConfig?.static?.regions;
    if (window.appConfig?.static?.regions) {
        return regions.map((r) => ({
            name: r.name,
            id: r.id,
            url: `//${r.host}`,
            el: null,
        }));
    }

    const lists = document.querySelector('.regionsPanelList')?.querySelectorAll('li') || [];
    const res: (SwitchCity & { el: HTMLElement })[] = [];
    lists.forEach((li) => {
        res.push({
            name: li.querySelector('a')?.getAttribute('title') || '',
            id: Number(li.dataset.id) || 0,
            url: li.querySelector('a')?.href || '',
            el: li,
        })
    });
    return res;
}

export function getCurrentCity(cities: SwitchCity[]): SwitchCity | null {
    const region = window.appConfig?.static?.currentRegion;
    if (region) {
        return cities.find((c) => c.id === region) || null;
    }

    const currentCity = cities.find((c) => c.name === document.querySelector('.regionSelect-js')?.textContent?.trim());
    return currentCity || null;
}
